import './SelectionResult.css';
import React, { Component } from 'react';
import SearchResultTable from './SearchResultTable';
import { withRouter } from 'react-router-dom';

class SelectionResult extends Component {
  render() {
    const { data } = this.props;
    return (
      <div>
        {data ? (
          <div>
            {data
              .sort((a, b) => a.categoryName.localeCompare(b.categoryName))
              .map(d => (
                <SearchResultTable
                  readOnly="true"
                  key={d.key}
                  rowKey={d.key}
                  data={d}
                  onProductsSelection={this.onProductsSelection}
                />
              ))}
          </div>
        ) : (
          <span />
        )}
      </div>
    );
  }
}

export default withRouter(SelectionResult);



// WEBPACK FOOTER //
// ./src/components/SelectionResult.js